import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@mui/material/IconButton";
import PlayArrowOutlinedIcon from "@mui/icons-material/PlayArrowOutlined";
import { Grid } from "@mui/material";
import Fade from '@mui/material/Fade';

const LibraryCard = (props) => {
  const classes = useStyles();
  return (
    <Fade in={true} timeout={500}>
    <Box
      sx={{
        display: "flex",
        flexFlow: "wrap",
        justifyContent: "center",
        mt: 2,
        alignContent: "center",
        alignItems: "center",
        cursor: "pointer",
        borderRadius: 3,
        background: "linear-gradient(135deg, rgba(180,227,145,1) 0%,rgba(97,196,25,1) 50%,rgba(180,227,145,1) 100%)",
        border: 1,
        borderColor: "#eaeaea",
      }}
    >
      <Grid
        container
        sx={{
          flexDirection: "row",
          justifyContent: "space-around",
          alignItems: "center",
          width: "19.9rem",
          borderRadius: 3,
          boxShadow: "3px 5px 5px 0px rgba(0,0,0,0.2)",
          "@media (min-width: 1636px)": {
            width: "25rem",
            height: "15rem",
          },
        }}
      >
        <Grid xs={5}>
          <Card
            sx={{ boxShadow: "none", backgroundColor: "transparent" }}
            onClick={props.press}
          >
            <CardMedia sx={{ textAlign: "center", paddingBottom: "0.6rem" }}>
              {props.img && (
                <img
                  src={`${sessionStorage.getItem('media_url')}image/${props.img}`}
                  className={classes.bookimg}
                ></img>
              )}
            </CardMedia>
          </Card>
        </Grid>
        <Grid xs={7}>
          <Card
            sx={{ boxShadow: "none", backgroundColor: "transparent" }}
            onClick={props.press}
          >
            <CardContent
              sx={{
                padding: "0.5rem !important",
              }}
            >
              <Typography
                className={classes.ModuleNum}
                sx={{ color: "#5f5600ff" }}
              >
                {props.title ? props.title : ""}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
    </Fade>
  );
};

const useStyles = makeStyles({
  ModuleNum: {
    fontSize: "1.1rem",
    textAlign: "left",
    fontWeight: "600",
    "@media (min-width: 1636px)": {
      fontSize: "1.4rem",
    },
  },
  bookimg: {
    width: "8rem",
    "@media (min-width: 1636px)": {
      width: "10rem",
    },
  },
});

export default LibraryCard;
